import { Button } from "@mixitone/components";
import SparkleIcon from "@mixitone/icons/sparkle.svg";
import { ApplicationView } from "@mixitone/mvc";
import { AppController } from "controllers/AppController";

const AgentButton = () => {
  const controller = AppController.use();
  const { newFeedbackMessages } = controller.state;

  const handleClick = () => {
    controller.actionShowAgent(true);
  };

  return (
    <Button
      kind="topNav"
      data-testid="agent-button"
      onClick={handleClick}
      className="relative @sm/app:block"
      style={{ height: "var(--mixitone-header-height)" }}
    >
      <SparkleIcon className="w-5 h-5 fill-purple-300" />
      {newFeedbackMessages && (
        <span className="absolute w-2 h-2 bg-orange-400 rounded-full top-1 right-1 animate-pulse" />
      )}
    </Button>
  );
};

export default ApplicationView(AgentButton);
